import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Sofía', 'Lucas', 'Valentina', 'Mateo', 'Camila', 'Agustín', 'Florencia', 'Martín', 'Lucía', 'Nicolás', 'Julieta', 'Tomás', 'Rocío'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Tucumán', 'Neuquén', 'Bahía Blanca', 'San Juan'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 15000); // Show first one after 15 seconds
    const interval = setInterval(() => {
      showNotification();
    }, 90000); // Every 1.5 minutes (90 seconds)
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const showNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-14">
      <div className="bg-white rounded-lg shadow-xl p-4 flex items-center border-l-4 border-mint max-w-xs" data-id="element-15">
        <div className="bg-mint/20 p-2 rounded-full mr-3" data-id="element-16">
          <CheckCircle className="w-6 h-6 text-chocolate" data-id="element-17" />
        </div>
        <div data-id="element-18">
          <p className="text-sm font-bold text-chocolate" data-id="element-19">¡Nueva compra!</p>
          <p className="text-xs text-gray-600" data-id="element-20">
            <span className="font-semibold" data-id="element-21">{data.name}</span> de {data.city}{' '}
            compró el pack.
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-22">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}